import React from 'react'
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import * as insights from "../../../../app/modules/Insights/_redux/insightsRedux";
import * as c2cConstants from "../../../../app/modules/Ticker/constants";
import { Tracker } from "../../../../app/util/analytics";
import * as helpers from "../../../../app/util/helpers";
import { resetInsightsPage, isDateInRange } from "../../../../app/util/helpers";
import { toAbsoluteUrl } from "../../../_helpers";
import CustomSwitch from '../../../../app/modules/Settings/pages/Settings/Util/CustomSwitch';
import { actions } from '../../../../app/modules/Auth/_redux/authRedux';
import WarningText from '../../../../app/util/WarningText';
import DisclaimerText from '../../../../app/util/DisclaimerText';
import { useMobileViewport } from '../../../../app/util/mobileViewPort';
import { setToastInfoForAccountStatus } from '../../../../app/modules/Auth/_redux/userProfileSlice';

export function HeaderMobile({
  handleMobileAsideMenu = () => {},
  isMenuOpened,
  paths,
}) {
  const dispatch = useDispatch();
  const location = useLocation();
  const isMobile = useMobileViewport();

  const isDuplicatedTab = useSelector(state => state.auth.is_duplicated_tab);

  const [breadcrumbTitle, setBreadcrumbTitle] = useState("");

  useEffect(() => {
    setBreadcrumbTitle(paths[location.pathname]);
    if (!location.pathname.includes("/insights")) {
      dispatch(insights.actions.selectedAgent(null));
    }
  }, [location.pathname]);

  let clickToCallHeader = helpers.isFeatureEnabled("ticker");

  const removeSelectedAgent = () => {
    dispatch(insights.actions.selectedAgent(null));
    resetInsightsPage(dispatch);
  };

  useEffect(() => {
    if(helpers.isFeatureEnabledProfile('hide_iframe_redirection')) return;
    const initialSwitchState = { ...JSON.parse(localStorage.getItem("switch_old_state")), [location.pathname]: false };
    try {
      const switchState = JSON.parse(localStorage.getItem("switch_old_state"))[location.pathname];
      if (switchState == null || switchState == undefined) localStorage.setItem("switch_old_state", JSON.stringify(initialSwitchState));
    } catch (error) { localStorage.setItem("switch_old_state", JSON.stringify(initialSwitchState)); }
  }, [location.pathname, JSON.parse(localStorage.getItem("switch_old_state"))])

  const switchOldHandler = (key) => {
    const cloneOldSwitchState = { ...JSON.parse(localStorage.getItem('switch_old_state')) };
    cloneOldSwitchState[key] = !JSON.parse(localStorage.getItem('switch_old_state'))[key];
    dispatch(actions.setSwitchToOld({ switch_old_state: cloneOldSwitchState }));
  }

  const customOldSrModules = [
  '/callflow', '/smsflow', '/integrations', 
  '/createcampaign', '/campaign', '/settings', '/history',
  '/settings', '/history', '/billstatement', '/invoices', '/payments', 
  '/billing_summary', '/reports', '/dashboard', '/insights', '/account_profile',
  '/live-interactions/queues-monitor', '/home', '/customer-management/customer'
  ];

  const dateInRange = isDateInRange('2024-03-18 00:00', '2024-03-22 02:30');

  return (
    <>
      <div
        style={{ zIndex: 1101 }}
        className={`header-mobile align-items-center `}
      >
        <div>
          <Link to="/">
            <img
              alt="logo"
              src={toAbsoluteUrl("/media/sr/logos/mobile-logo.svg")}
            />
          </Link>
          {clickToCallHeader ? (
            <span className="ml-3 mb-head-pg-title">{breadcrumbTitle}</span>
          ) : null}
        </div>
        {!clickToCallHeader ? (
          <span className="mobie-page-title">
            <span onClick={removeSelectedAgent}>{breadcrumbTitle}</span>
          </span>
        ) : (
          <></>
        )}

        <div className="d-flex align-items-center">
          {clickToCallHeader ? (
            <>
              {!customOldSrModules.includes(location.pathname) && !helpers.isFeatureEnabledProfile('hide_iframe_redirection') && !isMobile && 
                <div style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: 'center',
                  justifyContent: "center",
                  padding: "0 10px",
                }}>
                  <span className="mr-2" style={{
                    fontSize: 'smaller',
                    fontWeight: 600,
                    color: "grey",
                  }}>{'New UI'}</span>
                  <CustomSwitch onClickHandler={() => switchOldHandler(location.pathname)} state={(JSON.parse(localStorage.getItem('switch_old_state')) && JSON.parse(localStorage.getItem('switch_old_state'))[location.pathname])} path={location.pathname} />
                  <span className="ml-2" style={{
                    fontSize: 'smaller',
                    fontWeight: 600,
                    color: "grey",
                  }}>{'Old UI'}</span>
                </div>
              }
              {!helpers.isFeatureEnabledProfile('is_whatsapp_voice_enabled') && 
              <a
                href="#!"
                className="p-0 mr-2"
                onClick={() => {
                  if (isDuplicatedTab) {
                    dispatch(
                      setToastInfoForAccountStatus({
                        open: true,
                        snackbarMessage: "Please initiate C2C request from the Primary SR tab.",
                        severity: "warning",
                      })
                    );
                    return;
                  }
                  dispatch({ type: "Open", payload: {} });

                  Tracker.event(
                    c2cConstants.ANALYTICS.C2CWidgetClick_LEFT_NAV[0],
                    c2cConstants.ANALYTICS.C2CWidgetClick_LEFT_NAV[1],
                    c2cConstants.ANALYTICS.C2CWidgetClick_LEFT_NAV[2],
                    c2cConstants.ANALYTICS.C2CWidgetClick_LEFT_NAV[3],
                    helpers.getUser()
                  );
                }}
              >
                <img
                  alt="logo"
                  src={toAbsoluteUrl("/media/sr/icons/mobile-direct-call.svg")}
                />
              </a>
              }
              {/* ongoing call indicator */}
              {/* <a href="" className="mb-ongoing-call-btn">
                  <img className="ongoing-cl-logo" src={toAbsoluteUrl("/media/sr/icons/ongoing-call.svg")}/>
                  Ongoing
                </a> */}
            </>
          ) : null}

          {isMenuOpened ? (
            <img
              className="aside-menu-close-icon"
              alt="logo"
              src={toAbsoluteUrl("/media/sr/icons/close-icon.svg")}
              onClick={handleMobileAsideMenu}
            />
          ) : (
            <img
              className="aside-menu-open-icon"
              alt="logo"
              src={toAbsoluteUrl("/media/sr/icons/mobile-menu-open.svg")}
              onClick={handleMobileAsideMenu}
            />
          )}
        </div>
      </div>
      {isMobile && 
      <div>
            <div style={{ position: 'relative', overflow: 'hidden' }}>
                  {['/home', '/call-logs'].some(path => location.pathname.includes(path)) && dateInRange && <DisclaimerText
                      className="warning-slide3"
                      message="As part of a planned maintenance activity, New Call Logs will not be visible from 21st March 11.30 PM to 22nd March 2.30 AM. Rest assured no data loss will occur."
                  />}
                  {['/insights', '/dashboard', '/call-logs', '/smslogs'].some(path => location.pathname.includes(path)) ? (
                    <WarningText
                      className="warning-slide1"
                      message={helpers.isCountryIndia()
                        ? "<b>New Product:</b> Whatsapp Voice Calling is now LIVE. If you are interested to enable Whatsapp Voice, reach out to us on <a target='_balnk' href='https://wa.me/call/91865772185'>https://wa.me/call/918657721850</a>" 
                        : "<b>New Product:</b> Whatsapp Voice Calling is now LIVE. If you are interested to enable Whatsapp Voice, reach out to us on <a target='_balnk' href='https://wa.me/call/91865772185'>https://wa.me/call/918657721850</a>" 
                      }
                    />
                  ) : (
                    <WarningText
                      className="warning-slide2"
                      message={helpers.isCountryIndia()
                        ? "<b>New Product:</b> Whatsapp Voice Calling is now LIVE. If you are interested to enable Whatsapp Voice, reach out to us on <a target='_balnk' href='https://wa.me/call/91865772185'>https://wa.me/call/918657721850</a>" 
                        : "<b>New Product:</b> Whatsapp Voice Calling is now LIVE. If you are interested to enable Whatsapp Voice, reach out to us on <a target='_balnk' href='https://wa.me/call/91865772185'>https://wa.me/call/918657721850</a>" 
                      }
                    />
                  )}
            </div>
      </div>}
    </>
  );
}
